<template>
  <div class="admin-page">
    <div class="admin-page-inner admin-page-inner--compact">
      <div class="admin-page-header">
        <div>
          <span class="admin-kicker">Stammdaten</span>
          <h1 class="admin-page-title">Datenverwaltung</h1>
          <p class="admin-page-subtitle">
            Verträge, Tarife, Vorlagen und weitere Stammdaten verwalten.
          </p>
        </div>
      </div>
      <section class="admin-panel">
        <div class="admin-panel__body text-gray-600">
          Wählen Sie im Bereich „Datenverwaltung“ einen Eintrag aus.
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminData",
  created() {
    document.getElementById("mainspinner").style.display = "none";
    if (localStorage) localStorage.setItem("last", "/admin/data");
  },
};
</script>
